
import React from 'react';
import { Button } from '@/components/ui/button';
import { RefreshCcw } from 'lucide-react';

interface ErrorFallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

const ErrorFallback = ({ error, resetErrorBoundary }: ErrorFallbackProps) => {
  const isReactError = error.message?.includes("React") || 
                       error.message?.includes("Cannot access 'R' before initialization");
                       
  const handleRefresh = () => {
    // Try clearing any local storage that might be causing issues
    try {
      localStorage.removeItem('adminDashboardUploadState');
    } catch (e) {
      console.error("Failed to clear localStorage:", e);
    }
    
    // For React initialization errors, a full page reload is needed
    if (isReactError) {
      window.location.reload();
    } else {
      resetErrorBoundary();
    }
  };
  
  return (
    <div className="p-4 rounded-md bg-red-50 border border-red-200">
      <div className="flex flex-col items-center text-center p-6">
        <h2 className="text-xl font-semibold text-red-800 mb-2">
          {isReactError ? "Une erreur d'initialisation s'est produite" : "Une erreur s'est produite"}
        </h2>
        
        <p className="text-sm text-red-600 mb-4">
          {isReactError 
            ? "L'application n'a pas pu s'initialiser correctement." 
            : "Un problème est survenu lors du chargement de cette section."}
        </p>
        
        <Button 
          onClick={handleRefresh}
          variant="destructive"
          className="flex items-center gap-2"
        >
          <RefreshCcw size={16} />
          {isReactError ? "Recharger la page" : "Réessayer"}
        </Button>
        
        {isReactError && (
          <p className="text-xs text-gray-500 mt-3">
            Si le problème persiste, essayez de vider le cache de votre navigateur.
          </p>
        )}
      </div>
    </div>
  );
};

export default ErrorFallback;
